export function show(context) {
    context.commit('SHOW_LOADER');
}

export function hide(context) {
    context.commit('HIDE_LOADER');
}
